import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SecondaryButton from '../../buttons/SecondaryButton';
import customTheme from '../../../theme';

LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x');

function   UploadMetadataListDatagrid(props) {
    const { fileList, onDeleteFile, isUploading } = props;
    const columns = [
        {
            field: 'fileName',
            headerName: 'File Name',
            width: 260
        },
        {
            field: 'source',
            headerName: 'Source',
            width: 140
        },
        {
            field: 'delete',
            headerName: 'Delete',
            width: 80,
            sortable: false,
            renderCell: (params) => (
                isUploading ? (
                    <SecondaryButton
                        icon={
                            <CircularProgress
                                sx={{
                                    color: (theme) => customTheme.palette.secondary.main,
                                }}
                                thickness={5}
                            />
                        }
                    />
                ) : (
                    <SecondaryButton
                        onClick={() => handleDelete(params.row.id)}
                        hoverColor="red"
                        icon={<DeleteForeverIcon />}
                    />
                )
            ),
        },
    ];

    const [rows, setRows] = useState([])

    useEffect(() => {
        setRows(fileList.map((file, index) => (
            {
                id: index,
                fileName: file?.name ?? '',
                source: file?.source ?? ''
            }
        )))
        
    }, [fileList])

    const handleDelete = (id) => {
        const fileToDelete = fileList[id];
        onDeleteFile(fileToDelete);
    };

    return (
        <Box
            id="metadata-upload-list"
            sx={{
                backgroundColor: '#141414',
                borderRadius: '8px',
                height: 'auto',

                mt: 2, // margin-top: 2
                // p: 2, // padding: 2
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: 'white',
                position: 'relative'
            }}
        >
            <Box sx={{ height: '100%', width: '100%' }}>
                <DataGridPro
                    sx={{
                        backgroundColor: '#101010', // Change the background color of the data grid
                        borderColor: '#122218',
                        '& .MuiDataGrid-root': {
                            cursor: 'pointer', // Change the cursor to pointer when hovering over the data grid
                        },
                        '& .MuiDataGrid-cell:hover': {
                            color: 'rgb(76, 146, 107)',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            borderColor: 'green', // Make the separator green
                            borderWidth: '2px', // Set the thickness of the separator
                            visibility: 'visible', // Ensure the separator always visible
                            '&:hover': {
                                borderColor: 'rgb(76, 146, 107)', // Ensure the separator stays green on hover
                            },
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#101010', // Change the column header background to black
                        },
                        '& .MuiDataGrid-columnHeader': {
                            fontSize: '14px', // Customize the font size of the column headers
                            color: 'white', // Change the column header color to white
                            fontWeight: 'bold', // Make the column header text bold
                            borderBottom: 'None', // Change the bottom line color of the column headers
                        },
                        '& .MuiDataGrid-row': {
                            border: 'none', // Remove the row separator lines
                        },
                        '& .MuiDataGrid-rowCount': {
                            color: 'white', // Change the background color of the selected row
                        },
                        '& .MuiDataGrid-selectedRowCount': {
                            color: 'white', // Change the font color of the selected row count
                        },
                        '& .MuiDataGrid-cell': {
                            border: 'none', // Remove the cell separator lines
                            color: 'white', // Change the font color of the cells
                            fontSize: '13px', // Make the cell text smaller
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#161618', // Change the background color of odd rows
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#202020', // Change the background color of even rows
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: 'rgba(76, 146, 107, 0.1)', // Change the hover color of the row to light green with reduced opacity
                        },
                        '& .MuiDataGrid-cell--withRenderer': {
                            '& .MuiCheckbox-root': {
                                color: 'white', // Change the color of the checkbox
                                transform: 'scale(0.7)', // Make the checkbox smaller
                                '& .MuiSvgIcon-root': {
                                    borderRadius: '50%', // Make the checkbox a circle
                                },
                                '&.Mui-checked': {
                                    color: '#54a277', // Change the color of the selected checkbox to green
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderCheckbox': {
                            '& .MuiCheckbox-root': {
                                color: 'white', // Change the color of the checkbox in the column header
                                transform: 'scale(0.8)', // Make the checkbox smaller in the column header
                                '& .MuiSvgIcon-root': {
                                    borderRadius: '50%', // Make the checkbox a circle in the column header
                                },
                                '&.Mui-checked': {
                                    color: '#54a277', // Change the color of the selected checkbox to green in the column header
                                },
                            },
                        },
                        maxHeight: 400, // Adjust the height of the DataGrid
                        overflowY: 'auto', // Allow vertical scrolling
                    }}
                    rows={rows}
                    columns={columns}
                    pageSize={4}
                    disableRowSelectionOnClick
                    hideFooter
                    // rowHeight={80} // Adjust the row height to make rows more compact
                />
            </Box>
        </Box>
    );
}

export default UploadMetadataListDatagrid;